import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getContentTopicsList = async () => {
  return await axiosInstance.get("content-topics/getlist", { headers });
};

export const getContentTopicById = async (id) => {
  const response = await axiosInstance.get(`content-topics/get/${id}`, {
    headers,
  });
  return response.data.result;
};

export const addContentTopic = async (payload) => {
  return await axiosInstance.post("content-topics/add", payload, { headers });
};

export const updateContentTopic = async (payload) => {
  return await axiosInstance.put("content-topics/update", payload, { headers });
};

export const deleteContentTopic = async (id) => {
  return await axiosInstance.delete(`content-topics/delete/${id}`, { headers });
};
